import { FCI_APIS } from '~implementations/fci/constants/apis';

const GENERAL_APIS = {
  AUTHENTICATE_TENANTS: '/api/authenticate-tenants/',
  CALCULATOR: {
    CONFIG: '/api/calculator/calculators/config/',
    CALCULATE_TIME: (specialtyId: number) =>
      `/api/calculator/calculate/other-source/specialty/${specialtyId}/`,
    CALCULATE_PROJECTION: (specialtyId: number) =>
      `/api/calculator/calculate/monthly-projection-other-source/specialty/${specialtyId}/`
  },
  CORE: {
    CITY: '/api/core/city/',
    DEPARTMENT: '/api/core/department/',
    HOUSE_REFERENCE: '/api/people/house-reference/',
    IPS: '/api/core/ips/',
    NAV_BAR: '/api/core/nav-bar/',
    VERIFY_2FA: '/api/core/verify-2fa/ ',
    COUNTRY: '/api/core/country/',
    USER: '/api/core/users/',
    EDIT_PASSWORD: '/api/manage-users/edit-password/',
    LIST_GROUP_USERS: '/api/core/list-groups-users/',
    USERS_ALL_QUERY: '/api/core/all-users/'
  },
  SUPPORT_FILE: {
    PRESIGNED_URL: '/api/support_file/generate-pre-signed-url/',
    SUPPORT_FILES: '/api/support_file/support-files/',
    CATEGORIES: '/api/support_file/categories/'
  },
  MANAGE_USERS: {
    USERS_QUERY: '/api/manage-users/users-query/',
    GROUPS: '/api/manage-users/groups/',
    PRIVILEGES: '/api/manage-users/privileges/',
    USERS: '/api/manage-users/users/',
    USER_ACTION: '/api/manage-users/user-action/'
  },
  APPOINTMENT: {
    INTERNAL_PAYER: (search: string) => `/api/lacardio/agreements/${search}/`,
    BOOKING: '/api/appointment/booking/',
    CANCEL_REASONS: '/api/appointment/cancel-reasons/',
    BOOKING_RANGE: '/api/appointment/booking-range/',
    BOOKING_BY_DATE: '/api/appointment/booking-patients-by-date/',
    BOOKING_SPACE: '/api/appointment/booking-space/',
    CHECK: '/api/appointment/check/'
  },
  MASSIVE_LOAD: {
    CREATE_PATIENT: 'api/massive_load/requests/form/',
    FILE_REQUESTS: '/api/massive_load/file-requests/',
    FILE_TEMPLATE: '/api/massive_load/file-template/',
    FILE_LIST_202: '/api/massive_load/202/list/',
    PRESIGNED_URLS: '/api/massive_load/presigned-urls/',
    PRESIGNED_URL_FILE: (filename: string) =>
      `/api/massive_load/202/presigned-url/${filename}/`,
    SAVE_SIGNED_FILE: '/api/massive_load/202/create/',
    REQUEST_COMPRESS_RAR: '/api/massive-load/requests/rar/',
    TEMPLATE_FIELDS: (id: number) =>
      `/api/massive_load/cohorts/${id}/template-fields/`,
    REQUEST_COMPRESS_ZIP: '/api/massive-load/requests/zip/',
    REQUEST_CSV: '/api/massive-load/requests/csv/',
    REQUEST_RESULT: '/api/massive_load/request-results/',
    REQUEST_S3: '/api/massive_load/requests/s3/',
    REQUEST_TXT: '/api/massive-load/requests/txt/',
    REQUEST_XLS: '/api/massive-load/requests/xls/',
    REQUEST_XLSX: '/api/massive-load/requests/xlsx/',
    TEMPLATES: '/api/massive_load/templates/',
    TEMPLATES_202: '/api/massive_load/202/templates/'
  },
  NOTIFICATIONS: {
    ALERTS: '/api/notifications/alerts/',
    ALERTS_NOVELTY: '/api/notifications/alerts-novelty/',
    NOTIFICATION_SERVICE_PROVIDER:
      '/api/notifications/notification-service-provider/'
  },
  LOGIN: '/api/login/',
  LOGOUT: '/api/logout/',
  TOKEN: '/api/token/',
  TOKEN_REFRESH: 'api/token/refresh/',
  UFCA: {
    ANSWER: '/api/ufcas/answer/',
    ANSWERS: '/api/ufcas/answers/',
    ANSWERS_SOURCE: '/api/ufcas/answers-source/',
    MODULE_WITH_QUESTIONS: '/api/ufcas/module-with-questions/',
    SURVEYS: '/api/ufcas/surveys/',
    SURVEYS_DETAIL: '/api/ufcas/surveys-detail/',
    SURVEY_MODULES: '/api/ufcas/modules/',
    SURVEY_WORKUNIT_CONFIG: (surveyPk: number) =>
      `/api/ufcas/survey-workunit-config/${surveyPk}/`,
    DELETE_REGISTER: (surveyPatientPk: number) =>
      `/api/ufcas/survey-patient/${surveyPatientPk}/`,
    SURVEY_FINALIZED_FORM: '/api/ufcas/finalized-form/',
    SURVEY_PATIENT: '/api/ufcas/survey-patient/',
    SURVEY_PATIENT_MANY: '/api/ufcas/survey-patient-many/',
    SURVEY_PATIENT_LOGS: '/api/ufcas/survey-patient-log/',
    SURVEY_PATIENT_ANSWERS: 'api/ufcas/survey-patient-answers-grouped/',
    SURVEY_PATIENT_TO_PATIENT: '/api/ufcas/survey-patient-to-patient/',
    OPTIONS: '/api/ufcas/options/',
    PATIENT_BASE: '/api/people/patient-base/',
    PATIENT_BASE_WITH_DOCUMENT: '/api/people/patient-base-with-document/',
    QUESTIONS: '/api/ufcas/question/',
    QUESTION_HISTORY: '/api/ufcas/question-to-history/',
    QUESTION_FILTERS: '/api/ufcas/question-filters/',
    TRANSCRIBE: '/api/ufcas/transcribe-fill/',
    TRANSCRIBE_STATUS: '/api/ufcas/transcribe-status/',
    PRESIGNED_AUDIO_URL: '/api/ufcas/presigned-transcribe-audio/',
    PRESIGNED_ANSWER: '/api/ufcas/presigned-answer/',
    PRESUMPTIVE_ROUTE: '/api/ufcas/presumptive-route/',
    FLOW_SURVEYS: '/api/ufcas/flow-surveys/',
    FLOW_SURVEY: '/api/ufcas/flow-survey/',
    FLOW_SURVEY_ANSWERS: '/api/ufcas/flow-survey-answers/',
    SURVEY_PATIENT_ANSWERS_EXPORT: '/api/ufcas/survey-patient-answers-export/',
    SURVEY_MANAGEABLE: '/api/ufcas/survey-manageable/',
    SURVEY_PATIENT_ANSWERS_MANAGEABLE:
      '/api/ufcas/survey-patient-answers-manageable/',
    EXTRACTION_REQUEST: '/api/ufcas/extraction-request/',
    SURVEY_EXTRACTION_CONFIG: '/api/ufcas/survey-extraction-config/'
  },
  PEOPLE: {
    PATIENT: '/api/people/patient/',
    DOCUMENT_TYPES: '/api/people/document-type/',
    BH_PATIENT: (type: string, number: string) =>
      `/api/people/bh-patient-data/${type}/${number}/`
  },
  BILLING: {
    BILLING_VALIDATION: 'api/billing/billings-validation-patient/billing/',
    BILLING_PATIENT: (patientId: string) =>
      `/api/billing/billings-validation-billing/${patientId}/`,
    BILLING_CENTRAL_PHARMACY: (patientId: string) =>
      `/api/billing/billings-validation-central-pharmacy/${patientId}/`,
    BILLING_ROOM_HEAD: (patientId: string) =>
      `/api/billing/billings-validation-room-head/${patientId}/`,
    BILLING_WARD_DOCTOR: (patientId: string) =>
      `/api/billing/billings-validation-ward-doctor/${patientId}/`,
    BILLING_VALIDATION_ACTORS: '/api/billing/billing-validation/',
    BILLING_VALIDATION_CENTRAL_PHARMACY:
      '/api/billing/billings-validation-patient/central-pharmacy/',
    BILLING_VALIDATION_ROOM_HEAD:
      '/api/billing/billings-validation-patient/room-head/',
    BILLING_VALIDATION_WARD_DOCTOR:
      'api/billing/billings-validation-patient/ward-doctor/'
  },
  CHEMO: {
    EDUCATION: 'api/chemo/applications-first-with-protocol/',
    APPLICATION_PROCCESED: '/api/chemo/applications-processed/',
    CENTRAL_PHARMACY: 'api/chemo/applications-confirmed/',
    PHARMACEUTICAL_CHEMIST: '/api/chemo/applications-confirmed-episode-number/',
    APPLICATION_CONFIRMED_ADMISSIONS:
      '/api/chemo/applications-confirmed-admissions/',
    CYCLE: (uuid: string) => `/api/chemo/cycles/${uuid}/`,
    UPDATE_BILLING: (cyclePk: number) => `api/chemo/cycle/${cyclePk}/`,
    CYCLE_REPROGRAMMING: (uuid: string) =>
      `/api/chemo/re-programming-patient/${uuid}`,
    PATIENT_CHEMO: '/api/chemo/patient-chemo/',
    HIGH_COST_APPLICATION: '/api/chemo/application-medication-hight-cost/',
    PENDING_CONFIRMATION_APPLICATION:
      '/api/chemo/application-pending-confirmation/',
    REPROGRAMMING: 'api/chemo/re-programming/',
    PROGRAMMING_PATIENT: 'api/chemo/programming-patient',
    ROOMS: '/api/chairs_chemo/room/',
    CHAIR_VALIDATION: '/api/chairs_chemo/room/validation-chair/',
    PROTOCOLS: '/api/chemo/protocols/',
    CREATE_CYCLE: '/api/chemo/cycle/',
    UPDATE_CYCLE: (id: string) => `/api/chemo/cycle/${id}/`,
    APPLICATIONS: (patientId: string) =>
      `/api/chemo/applications-without-associated-cycle/${patientId}/`,
    HEAD_OF_PROGRAMMING: '/api/chemo/applications/head-of-programming/',
    PHARMACEUTICAL_CHEMISTS: '/api/chemo/applications/pharmaceutical-chemist/',
    APPLICATION_UPDATE_STATUS: '/api/chemo/application-status-u/',
    APPLICATION_VALIDATION_CREATE: '/api/chemo/application-validation/',
    CANCEL_APPLICATION: '/api/chemo/cancel-applications/',
    APPLICATION: '/api/chemo/applications/',
    UPDATE_APPLICATION_NUMBER: (cycleId: number) =>
      `api/chemo/cycle/episode-number/${cycleId}/`
  },
  MEDICAL_ORDERS: {
    MEDICAL_ORDERS: (patientId: string) =>
      `/api/medical_order/medical_order_without_associated_application/${patientId}/`
  },
  ROOM: {
    LOCATION_CREATE: '/api/room/location-create/',
    LOCATION_DESTROY: '/api/room/location-destroy/',
    LOCATIONS: '/api/room/locations/',
    PATIENT_LOCATION_CHANGE: (
      oldLocation: number,
      newLocation: number,
      patientUUID: string
    ) =>
      `/api/room/patient-location-change/${oldLocation}/${newLocation}/${patientUUID}/`,
    PACKETS: (cohort_id: number, patient_uuid: string) =>
      `/api/room/cohort/${cohort_id}/patient/${patient_uuid}/packets/`,
    PATIENT_ROOM: (cohort_id: string, room_id: number) =>
      `/api/room/patient-room/${cohort_id}/room/${room_id}`,
    PATIENTS_WITHOUT_ROOM: (cohort_id: string) =>
      `/api/room/patients-without-room/${cohort_id}/`,
    ROOM_UPDATE: '/api/room/room-update/',
    ROOMS: '/api/room/rooms/',
    SUBMIT_LOCATION: '/api/room/submit-location/'
  },
  WORK_LIST: {
    COHORT: '/api/cohort/cohorts/',
    GROUP: '/api/core/permissions-group/'
  },
  COHORT: {
    FORM_FIELDS: '/api/cohort/dynamic-forms/field-types/',
    MANAGE_COHORT: (cohort_id: number, object_id: number) =>
      `/api/manage/cohort/${cohort_id}/object/${object_id}/submit-ufca/`,
    CANCEL_PACKAGE: (cohort_id: number, package_id: number) =>
      `/api/manage/cohort/${cohort_id}/cancel-packet/${package_id}/`,
    COHORTS: '/api/manage/cohorts/',
    ACTIVITIES: (cohort_id: number, package_id: number) =>
      `/api/manage/control_tower/cohort/activity/${cohort_id}/packet/${package_id}/`,
    ACTIVITY_SCHEDULES: (cohort_id: number) =>
      `/api/manage/control_tower/activity-schedules/${cohort_id}/`,
    ACTIVITY_ASSIGNMENT: (cohort_id: number) =>
      `/api/manage/control_tower/activity-assignment/${cohort_id}/`,
    ACTIVITY_CANCEL: (cohort_id: number) =>
      `/api/manage/control_tower/activity-cancel/${cohort_id}/`,
    ACTIVITY_REPROGRAMING_CANCEL: '/api/khymei/cancel-booking/',
    ACTIVITY_DUPLICATE: (cohort_id: number) =>
      `/api/manage/control_tower/activity-duplicate/${cohort_id}/`,
    ADD_CLINIC_HISTORY: (cohort_id: number, package_id: number) =>
      `/api/manage/control_tower/cohort/${cohort_id}/packet/${package_id}/extras`,
    ACTIVITIES_GROUPED: (cohort_id: number, state: number) =>
      `/api/manage/cohort/${cohort_id}/state/${state}/patients/`,
    ACTIVITY_SCHEDULE_REVIEW: (cohort_id: number) =>
      `/api/khymei/bookings/${cohort_id}/`,
    ADD_ACTIVITIES: '/api/manage/control_tower/cohort/activity/add/',
    COHORT_LOCATION_TABLE: (cohort_id: number, location_id: number) =>
      `/api/room/cohort/${cohort_id}/location/${location_id}/`,
    COHORT_STATES: (pk: number) => `/api/manage/cohort/${pk}/states/`,
    COHORT_ACTIVITIES: (cohort_id: number, state_id: number) =>
      `/api/manage/cohort/${cohort_id}/state/${state_id}/patients/base/packet/`,
    COHORT_ACTIVITIES_BY_PATIENT: (cohort_id: number, state_id: number) =>
      `/api/manage/cohort/${cohort_id}/state/${state_id}/patients/base/id/`,
    COHORT_DYNAMIC_FILTER: (pk: number) =>
      `/api/manage/dynamic-filter/state/${pk}/`,
    COHORT_STATES_DATA: (pk: number, state: number) =>
      `/api/manage/cohort/${pk}/data/${state}/`, //TODO: MAYBE THISONE SHOULD BE REMOVED
    COHORT_CHANGE_STATE: (id: number) =>
      `/api/manage/cohort/submit-transaction/${id}/`,
    COHORT_CONTROL_TOWER_CONFIG: (id: number) =>
      `/api/manage/control_tower/cohort/${id}/config/`,
    COHORT_CONTROL_PACKETS: (cohort_id: number) =>
      `/api/manage/control_tower/cohort/${cohort_id}/packets/`,
    ADDITIONAL_ACTIVITIES: (cohort_id: number, packet_id: number) =>
      `api/manage/control_tower/list/additional/activities/cohort/${cohort_id}/packet/${packet_id}`,
    COHORT_EDIT_REGISTRY: (cohort_id: number, object_id: number) =>
      `/api/manage/cohort/${cohort_id}/object/${object_id}/update/`,
    COHORT_CHANGE_ROWS_STATE: `/api/manage/cohort/submit-transactions/`,
    AUTOMATIC_ASSIGNED_USER: '/api/cohort/automatic_assigned_user/',
    AUTOMATIC_ASSIGNED_GROUP: '/api/cohort/automatic_assigned_group/',
    MANUAL_ASSIGNED_USER: '/api/cohort/assigned_user/',
    MANUAL_ASSIGNED_GROUP: '/api/cohort/assigned_group/',
    COHORT_OBJECTS: (cohort_id: number) => `/api/cohort/${cohort_id}/objects/`,
    LIST_COHORT_STATES: '/api/cohort/list-cohort-states/',
    SUMMARY_COHORT: '/api/manage/summary-cohort/',
    SUMMARY_COHORT_LOGS: (cohort_id: number, object_id: number) =>
      `/api/manage/cohort/${cohort_id}/object/${object_id}/logs/`,
    PATIENT_HISTORY_COHORT: '/api/manage/patient-history-cohort/'
  },
  REPORTS: {
    DYNAMIC_REPORTS: '/api/reports/dynamic-reports/',
    REPORTS: '/api/reports/reports/',
    REQUESTS: '/api/reports/requests/'
  },
  POWER_BI: {
    DASHBOARD: (dashboardUUID: string) =>
      `/api/power_bi/reports/${dashboardUUID}/`
  },
  TASK_ASSIGNER: {
    ASSIGNMENT: '/api/task_assigner/assignment/',
    COHORT_FILTER_PARAMS: '/api/task_assigner/cohort-filter-params/',
    COHORT_FILTER_DISTINCT_FIELD:
      '/api/task_assigner/cohort-filter-distinct-field/',
    COUNT_ORDER_COHORT: '/api/task_assigner/count-order-cohort/',
    TASK_ASSIGNER: '/api/task_assigner/task-assigner/',
    VALIDATE_PENALTY: '/api/task_assigner/validate-penalty/',
    ORDERING_COMPLETED_GOAL: '/api/task_assigner/ordering-completed-goal'
  },
  TAGS: {
    MANAGE: '/api/manage/tag/',
    ASSIGN: '/api/manage/tag/assign/'
  },
  SANITAS: {
    BH_PATIENT_CREATION: '/api/sanitas/bh-patient-creation/'
  },
  HORIZONTE: {
    PATIENTS: '/api/colsanitas/patient-horizonte/',
    ACTIVITIES: (cohort_id: number, patient_uuid: string) =>
      `/api/colsanitas/activity-patient-horizonte/${cohort_id}/patient/${patient_uuid}/`,
    ACTIVITY_SCHEDULES: (cohort_id: number) =>
      `/api/colsanitas/activity-schedules/${cohort_id}/`,
    ACTIVITY_ASSIGNMENT: (cohort_id: number) =>
      `/api/colsanitas/activity-assignment/${cohort_id}/`,
    CREATE_ACTIVITIES: (cohort_id: number) =>
      `/api/colsanitas/create-activity-horizonte/${cohort_id}/`
  }
} as const;

export const APIS = {
  ...GENERAL_APIS,
  ...FCI_APIS
};
